import { getters } from "@/constants/state";

export default {
  [getters.AGENDAS_GETTER]: (state) => state.agendas,
};
